



































































import { IContract, IContractProduct } from "@/models/contracts";
import { IProduct } from "@/models/products";
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters({
      getBillingCycleName: "constants/getBillingCycleName"
    })
  }
})
export default class ChangeProductSwitcher extends Vue {
  @Prop({ required: true })
  public oldContract!: IContract;

  @Prop({ required: true })
  public oldProduct!: IContractProduct & {
    product: IProduct;
  };

  @Prop({ required: true })
  public newProduct!: any;

  @Prop({ default: false })
  public isProcessing!: boolean;

  // Computed

  public get recurringTaxSummary(): string {
    return this.$store.getters["brand/taxSummary"]({
      taxType: this.oldContract.brand.tax_type,
      taxAmount: this.oldProduct.tax_amount,
      taxIncPrice: this.oldProduct
        .configuration_total_recurring_amount_formatted,
      taxExcPrice: this.oldProduct
        .configuration_total_recurring_net_amount_formatted
    });
  }

  // Methods

  public readonly getBillingCycleName!: (month: number) => string;
}
